import * as React from "react";
import { useCountryValue } from "../Contexts/CountryContext";
var Fragment = React.Fragment;
function DDI(props) {
  var ddi = props.ddi;
  var doBreak = typeof props.break === "undefined" ? true : props.break;
  var state = useCountryValue()[0];
  var phoneInfo = state.callData.countries[state.country];
  var numberExtension = phoneInfo.numberExtension,
    mobileNumberExtension = phoneInfo.mobileNumberExtension;
  var extension = numberExtension;
  if (state.country === "de" && state.device === "mobile") {
    extension = mobileNumberExtension;
  }
  return /*#__PURE__*/React.createElement(Fragment, null, extension !== "" && doBreak === true ? /*#__PURE__*/React.createElement("br", null) : "", extension, " ", ddi);
}
export default DDI;